{
  "dashboard": {
    "title": "My Work Environment",
    "subtitle": "Your personal contribution to the company – processes, effort, systems and network.",

    "stats": {
      "activeProcesses": "Active Processes",
      "activeProcessesDesc_one": "Involvement",
      "activeProcessesDesc_other": "Involvements",
      "totalActivities_one": "Activity across processes",
      "totalActivities_other": "Activities across processes",
      "usedSystems": "Used Systems",
      "usedSystemsDesc_one": "System",
      "usedSystemsDesc_other": "Systems",
      "networkInteractions": "Network",
      "networkDesc_one": "Person",
      "networkDesc_other": "People",
      "direct": "Direct",
      "indirect": "Indirect"
    },
    "capacity": {
      "title": "Capacity Distribution",
      "subtitle": "Effort per process (hrs/month)"
    },
    "processes": {
      "title": "Processes & Activities",
      "activities_one": "{{count}} Activity",
      "activities_other": "{{count}} Activities",
      "noProcesses": "No processes yet"
    },
    "activities": {
      "unnamed": "{{type}} (in progress)"
    },
    "systems": {
      "title": "My Systems",
      "processCount_one": "{{count}} Process",
      "processCount_other": "{{count}} Processes",
      "noSystems": "No systems yet"
    },
    "coWorkers": {
      "title": "My Network",
      "all": "All",
      "direct": "Direct",
      "upstream": "Upstream",
      "downstream": "Downstream",
      "noCoWorkers": "No co-workers found",
      "noCoWorkersDirect": "No direct co-workers found",
      "noCoWorkersUpstream": "No upstream co-workers found",
      "noCoWorkersDownstream": "No downstream co-workers found"
    },
    "hoursSuffix": "{{value}}h"
  }
}
